import matchCurrentVolume from "../chronology/current/match-current-volume";
import sortByStartDates from "../chronology/sort-by-start-dates";
import findClosestSeason from "../resolve/find-closest-season";

export default function autoSeason(parentVolume, { state, getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  // The parent volume has no seasons, or is null.
  if (!parentVolume?.seasons.length) {
    return null;
  }

  const currentVolume = matchCurrentVolume({ state, getters });

  // If the parent volume is the current volume,
  // then we want the current or closest season.
  // Otherwise, we always want the first season.
  if (currentVolume && currentVolume === parentVolume) {
    const closestSeason = findClosestSeason(parentVolume, { state, getters });
    if (closestSeason) {
      return closestSeason;
    }

    // We found no current season, and no closest season
    // within the current volume.
  }

  // Sort the seasons to easily grab the first one.
  sortByStartDates(parentVolume.seasons);

  // Since the selected volume is not the current volume,
  // return the selected volume's first season.
  return parentVolume.seasons[0];
}
